export default class MouvementStockController {
	static $inject = [
		'$scope',
		'$state',
		'$uibModal',
		'MouvementStockService',
		'PaginationService',
		'notification',
		'$translate',
		'moment',
		'ModalService',
		'localStorageService',
		'MassiaAuthService'
	];

	constructor(
		$scope,
		$state,
		$uibModal,
		MouvementStockService,
		PaginationService,
		notification,
		$translate,
		moment,
		ModalService,
		localStorageService,
		MassiaAuthService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.MouvementStockService = MouvementStockService;
		this.PaginationService = PaginationService;
		this.notification = notification;
		this.$translate = $translate;
		this.moment = moment;
		this.ModalService = ModalService;
		this.localStorageService = localStorageService;
		this.loading = false;
		this.unregister = [];
		this.societes = [];
		this.regroupementsSite = [];
		this.produits = [];
		this.idSociete = null;
		this.idRegoupementSite = null;
		this.idProduit = null;
		this.idProducteur = null;
		this.dateDebut = null;
		this.dateFin = null;
		this.isValidDateInterval = false;
		this.movementProductDetails = null;
		this.MassiaAuthService = MassiaAuthService;
	}

	async $onInit() {
		await this.loadSocietes();

		const $stockSocieteId = this.localStorageService.get('STOCK_MOUV_STOCK_SOCIETE_ID');
		const $stockGrpSiteId = this.localStorageService.get('STOCK_MOUV_STOCK_GRPSITE_ID');

		//recuperation des params dans lurl : ?idSociete=${this.idSociete}&idRegoupementSite=${this.idSite}&idProduit=${idProduit}&date=${this.dateDebut}
		const { idSociete, idRegoupementSite, date, idProduit, idProducteur } = await this.getUrlParams();

		const societeId = idSociete || $stockSocieteId;

		if (Number(societeId) && this.societes.length > 0) {
			this.idSociete = Number(societeId); //Number est obligatoire pour convertir en nombre
			await this.loadRegroupementsSite();
		}

		if (idProduit) {
			this.idProduit = Number(idProduit); //Number est obligatoire pour convertir en nombre
		}
		if (idProducteur) {
			this.idProducteur = Number(idProducteur);
		}

		const regroupementSiteId = idRegoupementSite || Number($stockGrpSiteId);
		if (regroupementSiteId) {
			this.idRegoupementSite = Number(regroupementSiteId); //Number est obligatoire pour convertir en nombre
			await this.loadProduits();
		}

		if (date) {
			this.dateDebut = this.moment(date, 'DD/MM/YYYY').startOf('month').format('DD/MM/YYYY');
			this.dateFin = this.moment(date, 'DD/MM/YYYY').endOf('month').format('DD/MM/YYYY');
			await this.loadMouvementsStockByProduit();

			if (this.movementsStockProduit && this.movementsStockProduit.length > 0) {
				this.movementProductDetailsByDate = this.movementsStockProduit.find(
					(mouvement) => this.moment(mouvement.date).format('DD/MM/YYYY') === date
				);
			}
		}
	}

	async getUrlParams() {
		const params = {};

		const url = window.location.href;

		const urlParams = new URLSearchParams(url.split('?')[1]);

		urlParams.forEach((value, name) => {
			params[name] = value;
		});

		return params;
	}

	async loadSocietes() {
		try {
			this.societes = await this.MouvementStockService.getSocietes();
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	selectProduct() {
		if (this.selectedProduct && this.selectedProduct.length > 0) {
			const { id, idProducteur } = this.selectedProduct[0];
			this.idProduit = id;
			this.idProducteur = idProducteur;
		} else {
			this.notification.error('Aucun produit sélectionné');
		}
	}

	async loadRegroupementsSite() {
		this.idRegoupementSite = null;
		this.selectedProduct = null;
		this.idProduit = null;
		this.idProducteur = null;
		this.regroupementsSite = [];
		this.produitsAhead = [];
		this.produits = [];
		try {
			if (!this.idSociete) {
				return;
			}
			await this.localStorageService.set('STOCK_MOUV_STOCK_SOCIETE_ID', this.idSociete);
			this.regroupementsSite = await this.MouvementStockService.getRegroupementSites(this.idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async loadProduits() {
		this.idProduit = null;
		this.idProducteur = null;
		try {
			if (!this.idSociete || !this.idRegoupementSite) {
				return;
			}
			await this.localStorageService.set('STOCK_MOUV_STOCK_GRPSITE_ID', this.idRegoupementSite);
			this.produits = await this.MouvementStockService.getProduits(this.idRegoupementSite);
			this.produitsAhead = [];
			this.produits.forEach((produit) => {
				const newprod = {
					id: produit.id,
					idProducteur: produit.idProducteur,
					libelle: `[${produit.code}] ${produit.libelle} - ${produit.libelleProducteur}`
				};
				this.produitsAhead.push(newprod);

				if (this.idProduit == produit.id && this.idProducteur == produit.idProducteur) {
					this.selectedProduct = newprod;
				}
			});
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	changeDate() {
		if (this.dateDebut && this.dateFin) {
			const dateDebutFormated = this.moment(this.dateDebut, 'DD/MM/YYYY');
			const dateFinFormated = this.moment(this.dateFin, 'DD/MM/YYYY');
			// Check if the end date is before the start date
			if (this.moment(dateFinFormated).isBefore(dateDebutFormated)) {
				this.notification.error('La date de fin doit être supérieure à la date de début');
				this.isValidDateInterval = false;
			} else {
				// Check if the difference between the dates is more than 10 days
				const diffDays = dateFinFormated.diff(dateDebutFormated, 'days');
				if (diffDays > 31) {
					this.notification.error('La différence entre les dates ne doit pas dépasser 31 jours');
					this.isValidDateInterval = false;
				} else {
					this.isValidDateInterval = true;
				}
			}
		} else {
			this.isValidDateInterval = false;
		}
	}

	isValidForm() {
		return (
			this.idSociete !== null && this.idRegoupementSite !== null && this.idProduit !== null && this.dateDebut !== null && this.dateFin !== null
		);
	}

	async loadMouvementsStockByProduit() {
		if (!this.isValidForm()) {
			this.notification.error('Veuillez remplir tous les champs');
			return;
		}
		this.changeDate();
		if (!this.isValidDateInterval) {
			return;
		}

		this.startLoading();
		try {
			this.movementsStockProduit = await this.MouvementStockService.getMouvementsStockByProduit(
				this.idProduit,
				this.idProducteur,
				this.idRegoupementSite,
				this.dateDebut,
				this.dateFin
			);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	getMovementProductDetailsByDate(mouvementProduit) {
		this.movementProductDetailsByDate = mouvementProduit;
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
